import { mapPinType } from '../../constants';
import { handleChooseHotelRoomButtonClick } from '../../HotelComponent/ChooseHotelRoomButton';
export const getMapPinOnClickHandler = props => {
  const {
    type,
    hotelDetailURL,
    hotel,
    args
  } = props;
  if (type === mapPinType.HOTEL) {
    return handleChooseHotelRoomButtonClick({
      hotelId: hotel === null || hotel === void 0 ? void 0 : hotel.hotelId,
      args,
      detailURL: hotelDetailURL,
      clickedOnMap: 'Y'
    });
  }
  return () => {};
};